export default {"src":"/_next/static/media/tools.a6d5e095.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};